import { DraggableIcon } from '../../../assets/svgs/icons';
import ContextMenuIconButton from '../../ContextMenuIconButton';

interface FaqQuestionCellValue {
  id: number;
  question: string;
  draggable: boolean;
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
}

const FaqQuestionCell = ({ value }: { value: FaqQuestionCellValue }) => {
  const { id, question, draggable, onEdit, onDelete } = value;

  return (
    <span className={draggable ? 'draggable-name-cell-container' : 'non-draggable-name-cell-container'}>
      {draggable && <DraggableIcon />}
      <ContextMenuIconButton itemID={id} onEditClicked={() => onEdit(id)} onDeleteClicked={() => onDelete(id)} />
      <span className="brand-faqs-table__text">{question}</span>
    </span>
  );
};

export default FaqQuestionCell;
